export enum ScreenType {
    desktop,
    mobilePortrait,
    mobileLandscape,
    tabletPortrait,
    tabletLandscape
}
